module.exports = __webpack_public_path__ + "img/jinniao_icon02.40350ccc.png";